import { useState, useEffect } from 'react';
import Main from '../../../component/Main.jsx';
import ShowDetailDataGrid from "../../../component/common/dataGrid/ShowDetailDataGrid.jsx";
import axios from 'axios';
import ExcelDownload from '../../../component/common/button/ExcelDownload.jsx';
import { useNavigate } from 'react-router-dom';

import { Search16w, AddCircle16w, Calendar16w } from '../../../images/icons/icons_component.js';
import EcshgHnfCalender from '../10_operrslt_list/EcshgHnfCalender.jsx';

const EcshgHnf = () => {
    const navigate = useNavigate();
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
    const currentDay = String(today.getDate()).padStart(2, '0');

    const [emogList, setEmogList] = useState([]);

    const [searchParams, setSearchParams] = useState({
        searchCheck1: currentYear,
        searchCheck2: currentMonth,
        searchEmog: 'A1100014',
        searchGubun: '',
        searchType: '',
    });

    const searchParamsAdditional = { userAuth: localStorage.getItem("userAuth") };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['상세보기', '교육구분', '교육종류', '주요 내용', '일정', '장소', '비고']; //component화 
    const dataColumn = ['DETAIL_SN', 'RSLT_SE_NM', 'SE_NM', 'DC_CN', 'TR_EDC_DE', 'EDC_PLACE', 'GNRL_RM'];
    const apiCall = '/trmsapi/trnlst/ecshgHnfEdcTraingRsltTrnListSearch.do';
    const apiCntCall = '';
    const excelFileName = '교육 및 훈련';
    const excelHead = ['순번', '교육구분', '교육종류', '주요 내용', '일정', '장소', '비고'];
    const colWidth = ['8%','8%','8%','40%','10%','10%'];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: colWidth,
        wrapTF: true
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    const popupPropsInfo = {
        checked: ["DETAIL", "ATCH"],
        localStorageName: "ecshgHnfTrnData",
        popupAddress: "/nedis/trmsInfo/trms_ecshgHnfTrn_popup.do",
        height: '800'
    }

    if (searchParamsAdditional != null) {
        searchParamsAdditional.pageNum = parseInt(pageInfo.currentPage);
        searchParamsAdditional.displayRowsize = parseInt(pageInfo.itemsPerPage);
    }

    const totalObj = Object.assign({}, searchParams, searchParamsAdditional);

    const fetchData = async () => {
        try {
            delete totalObj.validationCheckList;
            const response = await axios.get(apiCall,
                { params: totalObj }
            );
            setState(prev => ({
                ...prev,
                dataList: response.data,
                isSearched: true
            }));
            if (apiCntCall === '') {
                setPageInfo(prev => ({
                    ...prev,
                    totalItems: response.data.length
                }));
            } else {
                fetchDataCnt();
            }
            setState(prev => ({
                ...prev,
                isLoading: false
            }));
        } catch (error) {
            console.error('데이터 로딩 중 오류 발생:', error);
        }
    };

    const fetchDataCnt = async () => {
        try {
            const response = await axios.get(apiCntCall,
                { params: totalObj }
            );
            setPageInfo(prev => ({
                ...prev,
                totalItems: response.data
            }));
        } catch (error) {
            console.error('데이터 카운터 중 오류 발생:', error);
        }
    };

    useEffect(() => {
        if (state.isSearched) {
            setState(prev => ({
                ...prev,
                isLoading: true
            }));
            fetchData();
        }
    }, [pageInfo.currentPage]);

    const search = () => {
        setState(prev => ({
            ...prev,
            isSearched: false,
            isLoading: true
        }));
        setPageInfo(prev => ({
            ...prev,
            currentPage: 1,
        }));
        fetchData();
    };

    const add = () => {
        const senData = {
            flag: "add",
            IEM_ID: currentYear + currentMonth,
            TR_OPMT_DT: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        }

        let popup = null;

        if (state.isSearched) {
            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=1010, height=750, top=30, left=30");
        }
    };

    const schdul = () => {
        const senData = {
            flag: "add",
            IEM_ID: currentYear + currentMonth,
            TR_OPMT_DT: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
            schdulFlag: "schdul",
        }

        let popup = null;

        if (state.isSearched) {
            localStorage.setItem(popupPropsInfo.localStorageName, JSON.stringify(senData));
            popup = window.open(popupPropsInfo.popupAddress, "팝업", "scrollbars=1, resizable=0, width=1010, height=800, top=30, left=30");
        }
    };

    const [calendar, setCalender] = useState(false);

    useEffect(() => {
        const fetchHospList = async () => {
            try {
                const response = await axios.get('/trmsapi/trnlst/trmsEmogList.do', {
                    params: {}
                });
                setEmogList(response.data.trnEmogList || []);
            } catch (error) {
                console.error('병원 목록 로딩 중 오류 발생:', error);
            }
        };
        fetchHospList();
    }, []);

    useEffect(() => {
        search();
    }, [searchParams.searchEmog, searchParams.searchCheck1, searchParams.searchCheck2, searchParams.searchGubun, searchParams.searchType])

    const getNextMonthStr = (monthStr) => {
        let nextMonth = parseInt(monthStr, 10) + 1;
        if (nextMonth > 12) nextMonth = 1;
        return nextMonth < 10 ? "0" + nextMonth : "" + nextMonth;
    };

    const getNextYear = (yearStr) => {
        let nextYear = parseInt(yearStr);
        if (searchParams.searchCheck2 === '12') { nextYear += 1; }
        return nextYear;
    }

    return (
        <Main>
            {calendar ?
                <EcshgHnfCalender
                    searchYear={searchParams.searchCheck1}
                    searchMonth={searchParams.searchCheck2}
                    searchURI='/trmsapi/trnlst/getEcshgHnfSchduleTrnList.do'
                    setCalender={setCalender}
                />
                :
                <>
                    <div className="com-search">
                        <table>
                            <colgroup>
                                <col width="13%" />
                                <col width="20%" />
                                <col width="13%" />
                                <col width="20%" />
                                <col width="13%" />
                                <col width="20%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>조회기간</th>
                                    <td>
                                        <div className='flex gap-1'>
                                            <select id="searchCheck1"
                                                name="searchCheck1"
                                                value={searchParams.searchCheck1}
                                                onChange={handleInputChange}
                                            >
                                                {Array.from({ length: 10 }, (_, i) => {
                                                    const year = (currentYear - i).toString()
                                                    return (
                                                        <option key={year} value={year}>
                                                            {year}년
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                            <select id="searchCheck2"
                                                name="searchCheck2"
                                                value={searchParams.searchCheck2}
                                                onChange={handleInputChange}
                                            >
                                                {Array.from({ length: 12 }, (_, i) => {
                                                    const month = (i + 1).toString().padStart(2, '0');
                                                    return (
                                                        <option key={month} value={month}>
                                                            {month}월
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        </div>
                                    </td>
                                    <th>기관명</th>
                                    <td>
                                        <select
                                            name='searchEmog'
                                            className='w-full'
                                            value={searchParams.searchEmog}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">선택</option>
                                            {emogList.map(hosp => (
                                                <option key={hosp.EMOGCODE} value={hosp.EMOGCODE}>
                                                    {hosp.EMOGDESC}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <th>교육종류</th>
                                    <td>
                                        <select
                                            id="searchGubun"
                                            name="searchGubun"
                                            className='w-full'
                                            value={searchParams.searchGubun}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">전체</option>
                                            <option value="ED01">국내학회</option>
                                            <option value="ED04">국내교육</option>
                                            <option value="ED05">주기교육</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th>교육 구분</th>
                                    <td colSpan={2}>
                                        <select
                                            id="searchType"
                                            name="searchType"
                                            className='w-half'
                                            value={searchParams.searchType}
                                            onChange={handleInputChange}
                                        >
                                            <option value="">전체</option>
                                            <option value="10">예정</option>
                                            <option value="20">실적</option>
                                        </select>
                                    </td>
                                    <td colSpan={3}>
                                        <h5 className='bg-yellow co_dark w-fit px-2'>** {searchParams.searchCheck1}년 {searchParams.searchCheck2}월 실적 등록 가능 기간 : {searchParams.searchCheck1}-{searchParams.searchCheck2}-11 ~ {getNextYear(searchParams.searchCheck1)}-{getNextMonthStr(searchParams.searchCheck2)}-10 까지</h5>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='search_btn_wrapper'>
                        <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{pageInfo.totalItems}</strong>건</span>
                        <div className='btn_container'>
                            {(currentYear.toString() + currentMonth.toString() + currentDay.toString()) >= (searchParams.searchCheck1.toString() + searchParams.searchCheck2.toString() + '11') && (currentYear.toString() + currentMonth.toString() + currentDay.toString()) <= (getNextYear(searchParams.searchCheck1) + getNextMonthStr(searchParams.searchCheck2) + '10') ?
                                <button onClick={add} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_co_black'><AddCircle16w />실적추가</button> : ''}
                            <button onClick={schdul} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_co_black'><AddCircle16w />계획추가</button>
                            <button onClick={search} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_tr_primary'><Search16w />조회</button>
                            <button onClick={() => setCalender(true)} disabled={state.isLoading ? 'disabled' : ''} className='search_btn bg_co_green'><Calendar16w />일정공유</button>
                            <ExcelDownload
                                excelHead={excelHead}
                                excelData={state.dataList}
                                searched={state.isSearched}
                                dataCode={dataColumn}
                                excelFileName={excelFileName}
                            />
                        </div>
                    </div>
                    <ShowDetailDataGrid
                        propsInfo={propsInfo}
                        state={state}
                        pageInfo={pageInfo}
                        setPageInfo={setPageInfo}
                        searchParams={searchParams}
                        popupPropsInfo={popupPropsInfo}
                    />
                </>
            }
        </Main>
    )
}
export default EcshgHnf;